import * as z from "zod";

export const getShipmentErrors = {
  name: "getShipmentErrors" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    totalShipments: z.number(),
    errorShipments: z.number(),
    errorRate: z.number(),
  }),
};
